// extracted by mini-css-extract-plugin
export default {"inactiveButton":"Tabs_inactiveButton__37Max","activeButton":"Tabs_activeButton__gwKTi","container":"Tabs_container__ssGJc"};